var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcreteMixer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 38",
    width: 200,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "concrete-mixer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #f69125 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_216599808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_216600936",
    fillRule: "evenodd",
    className: "s0",
    d: "m16 31.9v-4h0.4c0.4 0 0.7-0.4 0.7-0.8v-6.1c0.1 0 0.7 0 0.7 0 0.3 0 0.6-0.2 0.6-0.5l1.5-4.7c0.1-0.4 0.4-0.6 0.7-0.6h7.5c0.4 0 0.8 0.4 0.8 0.8v8.7h-0.8v2h-4.9c-0.5 0-1 0.3-1.3 0.8l-2.1 3.7q-0.1 0-0.1 0.1l-0.4 0.6zm6.7-9.3c-0.2 0-0.4 0.2-0.4 0.4 0 0.2 0.2 0.4 0.4 0.4h2.4c0.2 0 0.4-0.2 0.4-0.4 0-0.2-0.2-0.4-0.4-0.4zm-3.6-0.8h5.2c0.7 0 1.3-0.5 1.3-1.2v-4.6h-4.2c-0.4 0-0.6 0.2-0.7 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216600864",
    fillRule: "evenodd",
    className: "s0",
    d: "m29.9 25.4h29.3v7.6h-1c0-2.4-2-4.4-4.4-4.4-2.5 0-4.4 2-4.4 4.4h-1c0-2.4-2-4.4-4.4-4.4-2.5 0-4.5 2-4.5 4.4h-1v-0.8c0-0.8-0.7-1.5-1.5-1.5h-3.8c-0.9 0-1.5 0.7-1.5 1.5v0.8h-0.7c0-2.4-2-4.4-4.4-4.4-2.4 0-4.4 2-4.4 4.4h-1.7l0.8-1.3q0.1-0.1 0.1-0.1l2.2-3.7c0.1-0.3 0.4-0.4 0.6-0.4h4.9c0.4 0 0.8-0.3 0.8-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216601224",
    fillRule: "evenodd",
    className: "s1",
    d: "m26.6 29.4c2 0 3.6 1.6 3.6 3.6 0 2-1.6 3.6-3.6 3.6-2 0-3.6-1.6-3.6-3.6 0-2 1.6-3.6 3.6-3.6zm-1.5 3.6c0 0.8 0.6 1.5 1.5 1.5 0.8 0 1.5-0.7 1.5-1.5 0-0.9-0.7-1.6-1.5-1.6-0.9 0-1.5 0.7-1.5 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216600576",
    fillRule: "evenodd",
    className: "s1",
    d: "m44 29.4c2 0 3.6 1.6 3.6 3.6 0 2-1.6 3.6-3.6 3.6-2.1 0-3.7-1.6-3.7-3.6 0-2 1.6-3.6 3.7-3.6zm-1.6 3.6c0 0.8 0.7 1.5 1.6 1.5 0.8 0 1.5-0.7 1.5-1.5 0-0.9-0.7-1.6-1.5-1.6-0.9 0-1.6 0.7-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216600552",
    fillRule: "evenodd",
    className: "s1",
    d: "m53.8 29.4c2 0 3.6 1.6 3.6 3.6 0 2-1.6 3.6-3.6 3.6-2 0-3.7-1.6-3.7-3.6 0-2 1.7-3.6 3.7-3.6zm-1.6 3.6c0 0.8 0.7 1.5 1.6 1.5 0.8 0 1.5-0.7 1.5-1.5 0-0.9-0.7-1.6-1.5-1.6-0.9 0-1.6 0.7-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216600384",
    fillRule: "evenodd",
    className: "s0",
    d: "m33.8 24.7l0.6-5.3c0.2-1.4 1.2-2.5 2.6-2.5 1.4 0 2.6 1.1 2.5 2.5l-0.6 5.3zm1.8-4.4c0 0.6 0.6 1.2 1.3 1.2 0.6 0 1.2-0.6 1.2-1.2 0-0.7-0.6-1.3-1.2-1.3-0.7 0-1.3 0.6-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216600192",
    fillRule: "evenodd",
    className: "s0",
    d: "m34 10.7l13.9-8 8.4 14.7-13.8 8-2.4-4.1 0.2-1.8q0-0.7-0.3-1.4c-0.5-1.2-1.7-1.9-2.9-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216600480",
    className: "s0",
    d: "m52.2 25.7c0.1 0.4 0.6 0.6 1 0.5 0.4-0.2 0.5-0.6 0.4-1l-1.9-5c-0.2-0.4-0.6-0.6-1-0.5-0.4 0.2-0.6 0.6-0.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216599856",
    fillRule: "evenodd",
    className: "s1",
    d: "m33.2 31.5h3.8c0.4 0 0.7 0.3 0.7 0.7v1.9c0 0.4-0.3 0.8-0.7 0.8h-3.8c-0.4 0-0.8-0.4-0.8-0.8v-1.9c0-0.4 0.4-0.7 0.8-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216599736",
    fillRule: "evenodd",
    className: "s0",
    d: "m33.6 11.6l-2.6 5.7 2.4 4.2 0.3-2.2c0.1-1.5 1.1-2.8 2.6-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_216599568",
    fillRule: "evenodd",
    className: "s0",
    d: "m56.7 16.5l2.6-5.6-4.2-7.5-6.3-0.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcreteMixer);
export default __webpack_public_path__ + "static/media/concrete-mixer.4c2ce6e723357efb2de033727015c044.svg";
export { ForwardRef as ReactComponent };